import { useState } from "react";
import { FAQS } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

export default function Guide() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="guide" className="mx-auto max-w-7xl px-4 md:px-6 py-16">
      <div className="grid gap-8 lg:grid-cols-2">
        <div>
          <SectionHeading
            kicker="吃瓜指南"
            title="新瓜友必读手册"
            desc="第一次来吃瓜？关于前排围观、蹲后续与追更订阅的问题，这里一次性讲明白，让你秒变资深吃瓜群众。"
          />
          <div className="mt-8 rounded-xl border border-background-200 bg-background-100 p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <i className="ri-emotion-happy-line text-accent-600"></i>
              吃瓜守则
            </h3>
            <ul className="mt-3 grid gap-2 text-sm text-foreground-700">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-accent-600"></i>
                理性围观，看热闹不添乱
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-accent-600"></i>
                不传谣不信谣，等官方说法
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-accent-600"></i>
                尊重当事人，评论有边界
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-200 bg-primary-50/40" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                  <span
                    className={`grid h-7 w-7 shrink-0 place-items-center rounded-full transition-transform ${
                      open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-4 text-sm leading-6 text-foreground-700 animate-pop">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}